// /src/state — pure config resolution (no I/O). Given the loaded parameter
// catalog + config_values rows, resolve the effective value for a scope.
//
// Precedence (§12.4): dc → design → category → global → factory default.
// Expired rows (expires_on strictly before `today`) are ignored.
// Sub-keyed params (K2, P4 use status) must also match sub_key; the factory
// default for those is a map keyed by sub_key.

const TIER_PRECEDENCE = { dc: 1, design: 2, category: 3, global: 4 };

function isLive(row, today) {
  if (!row.expires_on) return true;
  return row.expires_on >= today; // ISO date strings compare lexicographically
}

// scope = { dc, design, category }  (any may be undefined)
// subKey = status/size or undefined
export function resolveConfigValue(param, configValues, scope, subKey, today) {
  const t = today || new Date().toISOString().slice(0, 10);

  const candidates = configValues
    .filter((r) => r.param_id === param.id)
    .filter((r) => (subKey == null ? r.sub_key == null : r.sub_key === subKey))
    .filter((r) => isLive(r, t))
    .filter((r) => {
      if (r.scope_tier === 'global') return true;
      if (r.scope_tier === 'dc') return scope.dc != null && r.scope_key === scope.dc;
      if (r.scope_tier === 'design') return scope.design != null && r.scope_key === scope.design;
      if (r.scope_tier === 'category') return scope.category != null && r.scope_key === scope.category;
      return false;
    })
    .sort((a, b) => TIER_PRECEDENCE[a.scope_tier] - TIER_PRECEDENCE[b.scope_tier]);

  if (candidates.length > 0) {
    return { value: candidates[0].value, source: candidates[0].scope_tier, row: candidates[0] };
  }

  // Factory fallback from the catalog.
  const dv = param.default_value;
  if (subKey != null && dv && typeof dv === 'object' && !Array.isArray(dv) && subKey in dv) {
    return { value: dv[subKey], source: 'factory', row: null };
  }
  return { value: dv, source: 'factory', row: null };
}
